<template>
  <transition name="fade">
    <div
      v-if="active"
      class="bg-black bg-opacity-75 fixed inset-0 z-10000 m-0 p-2 md-lg:p-6 flex justify-center"
      @click.stop="canClose ? close() : null"
    >
      <div
        class="modal flex justify-center max-h-full my-auto relative w-full bg-white shadow rounded md-lg:rounded-lg"
        :class="[
          {
            'flex-col md-lg:flex-row h-full md-lg:h-auto': split,
            'lock-aspect-ratio': lockAspectRatio && !small,
            'px-4 py-5': padded,
            'modal-small': small,
          },
          padded ? (small ? 'pt-10 sm:p-10' : 'sm:p-6') : '',
          yScrollClass,
        ]"
        @click.stop="() => {}"
      >
        <slot />

        <CloseButton
          v-if="canClose"
          class="right-2 top-2 -mr-0.5 -mt-0.5"
          @click.native="close"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import CloseButton from '@/components/CloseButton'
import { EventBus, Events } from '@/lib/events'

export default {
  components: { CloseButton },

  props: {
    scope: { type: String, required: true },
    padded: { type: Boolean, default: true },
    split: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    canClose: { type: Boolean, default: true },
    lockAspectRatio: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    yScroll: { type: Boolean, default: true },
    overflowVisible: { type: Boolean, default: false },
  },

  computed: {
    /**
     * A GA friendly name for this modal.
     */
    modalName() {
      return this.scope || this.$parent._name
    },

    yScrollClass() {
      if (this.yScroll) return 'overflow-y-auto'

      if (this.overflowVisible) return ''

      return 'overflow-hidden'
    },
  },

  watch: {
    /**
     * Fire a GA event when the modal is opened.
     */
    active(active) {
      if (active) {
        EventBus.$emit(Events.ModalOpen, {
          name: this.scope,
        })

        document.querySelector('html').classList.add('overflow-hidden')
      } else {
        document.querySelector('html').classList.remove('overflow-hidden')
      }
    },
  },

  beforeDestroy() {
    document.querySelector('html').classList.remove('overflow-hidden')
  },

  methods: {
    close() {
      EventBus.$emit(Events.ModalClose, {
        name: this.scope,
      })

      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  max-width: 61.25rem;

  &.lock-aspect-ratio {
    @screen md-lg {
      aspect-ratio: 16/9;
    }
  }

  &-small {
    max-width: 27.5rem;
  }
}
</style>
